// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

// Images
import bgImage from "../../../assets/images/shapes/waves-white.svg";

function Download() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 4 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 8 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white"  mb={2}>
              Love what we do?
            </MKTypography>
            <MKTypography variant="body2" color="white" mb={1}>
            We're a community dedicated to empowering  and uplifting rural India through technological innovation. 
            </MKTypography>
            <MKTypography variant="h5" color="white">
              Get in touch with us today 
            </MKTypography>
            <MKTypography variant="h5" color="white">
              let's create something exceptional together and make a difference!
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      
    </MKBox>
  );
}

export default Download;
